<template>
    <div class="invoice-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="invoice-header mb-24 d-flex justify-content-between">
                    <div class="invoice-left-text">
                        <h3 class="mb-0">Joxi Invoice #0011</h3>
                        <p class="mt-2 mb-0">S/2856, <br>Quadra Street, <br>Victoria, <br>USA.</p>
                    </div>

                    <div class="invoice-right-text">
                        <h3 class="mb-0 text-uppercase">#Invoice</h3>
                    </div>
                </div>

                <div class="invoice-middle mb-24">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="text">
                                <h4 class="mb-2">Bill To</h4>
                                <span class="d-block mb-1">California S Home</span>
                                <span class="d-block mb-1">2022 Redbud Drive</span>
                                <span class="d-block">New York, NY 99999</span>
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="text">
                                <h4 class="mb-2">Ship To</h4>
                                <span class="d-block mb-1">California S Home</span>
                                <span class="d-block mb-1">2022 Redbud Drive</span>
                                <span class="d-block">New York, NY 99999</span>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="text text-end">
                                <h5>Invoice # <sub>Int-003</sub></h5>
                                <h5>Invoice Date # <sub>29/09/2022</sub></h5>
                                <h5>P.O # <sub>4525/2022</sub></h5>
                                <h5 class="mb-0">Due Date # <sub>06/10/2022</sub></h5>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="invoice-table table-responsive mb-24">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Description</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>01</td>
                                <td>M1 chip MacBook Air</td>
                                <td class="text-end">$999.00</td>
                                <td class="text-end">$999.00</td>
                            </tr>

                            <tr>
                                <td>01</td>
                                <td>M2 chip MacBook Air</td>
                                <td class="text-end">$1199.00</td>
                                <td class="text-end">$1100.00</td>
                            </tr>

                            <tr>
                                <td>01</td>
                                <td>iPhone 13 Pro</td>
                                <td class="text-end">$900.99</td>
                                <td class="text-end">$900.99</td>
                            </tr>

                            <tr>
                                <td>01</td>
                                <td>iPhone 14 Pro Max</td>
                                <td class="text-end">$1100.99</td>
                                <td class="text-end">$1100.99</td>
                            </tr>

                            <tr>
                                <td class="text-end" colspan="3"><strong>Subtotal</strong></td>
                                <td class="text-end">$4099.99</td>
                            </tr>

                            <tr>
                                <td class="text-end" colspan="3"><strong>Sales Tax 4.0%</strong></td>
                                <td class="text-end">$200.99</td>
                            </tr>

                            <tr>
                                <td class="text-end total" colspan="3"><strong>Total</strong></td>
                                <td class="text-end total-price"><strong>$3899</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="invoice-btn text-end">
                    <a href="#" class="default-btn">Print</a>
                    <a href="#" class="default-btn">Send Invoice</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InvoiceContent'
}
</script>

<style lang="scss">
.invoice-header {
    h3 {
        font: {
            size: 18px;
            weight: 600;
        };
    }
}
.invoice-middle {
    h4 {
        font: {
            size: 16px;
            weight: 600;
        };
    }
    h5 {
        margin-bottom: 12px;
        font-weight: 600;
		font-size: 16px;
        sub {
            margin-left: 50px;
            bottom: 0;
            width: 90px;
            display: inline-block;
            color: var(--body-color);
            font: {
                weight: 400;
                size: var(--font-size);
            };
        }
    }
    span {
        font: {
            weight: 400;
            size: var(--font-size);
        };
    }
}
.invoice-table {
    table {
        margin-bottom: 0;

        thead {
            th {
                text-align: center;
                vertical-align: middle;
                border-bottom: 1px solid #eeeeee;
                font: {
                    size: var(--font-size);
                    weight: 600;
                };
                padding: {
                    top: 10px;
                    bottom: 10px;
                    left: 15px;
                    right: 15px;
                };
            }
        }
        tbody {
            td {
                vertical-align: middle;
                color: var(--body-color);
                border-width: 1px;
                font: {
                    size: 14px;
                };
                padding: {
                    top: 10px;
                    bottom: 10px;
                    left: 15px;
                    right: 15px;
                };
                &.total, &.total-price {
                    color: var(--heading-color);
                    font-size: 14px;
                }
            }
        }
    }
}
.invoice-btn {
    .default-btn {
        transition: var(--transition);
        text-decoration: none;
        padding: 13px 35px 12px;
        border-radius: 30px;
        display: inline-block;
        transition: var(--transition);
        background-color: var(--main-color);
        color: var(--white-color);
        margin-right: 10px;
        &:hover, &:focus {
            background-color: var(--heading-color);
            color: var(--white-color);
        }
    }
    .optional-btn {
        transition: var(--transition);
        text-decoration: none;
        padding: 13px 35px 12px;
        border-radius: 30px;
        text-transform: uppercase;
        display: inline-block;
        transition: var(--transition);
        background-color: #3578e5;
        color: var(--white-color);
        font: {
            size: 14px;
            weight: 700;
        };
        &:hover, &:focus {
            background-color: var(--heading-color);
            color: var(--white-color);
        }
    }
}
</style>